export const getSx = () => ({
  spineWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  content: {
    textWrap: 'auto',
    width: '59vw',
    boxSizing: 'border-box',
    textAlign: 'justify',

    '*': {
      backgroundColor: 'transparent !important',
      color: 'white !important', // Apply to all child elements
    },
    '*:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6)': {
      color: 'rgba(189, 189, 189, 1) !important', // Other elements with greyish color
    },
  },
});
